export enum CustomerAssessmentResultColorsEnum {

    not_applicable = '',
    poor = '#902727',
    below_average = '#8d5555',
    average = '#908e27',
    good = '#558d60',
    excellent = '#27903b'

}